import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class ChannelThemeService {

  parseChannelColors(
    color: string | null
  ): { primary?: string; secondary?: string; tertiary?: string; highlight?: string } | null {
    if (!color) return null;

    try {
      const parsed = JSON.parse(color);

      return {
        primary: parsed?.primary || undefined,
        secondary: parsed?.secondary || undefined,
        tertiary: parsed?.tertiary || undefined,
        highlight: parsed?.highlight || undefined
      };
    } catch (e) {
      console.error('Erro ao fazer parse das cores do canal:', e);
      return null;
    }
  }

  applyChannelColors(colors?: {
    primary?: string;
    secondary?: string;
    tertiary?: string;
    highlight?: string;
  }) {
    if (!colors) return;

    const root = document.documentElement;

    root.setAttribute('channel-theme', 'custom');

    if (colors.primary) {
      root.style.setProperty('--channel-primary-color', colors.primary);
    }

    if (colors.secondary) {
      root.style.setProperty('--channel-secondary-color', colors.secondary);
    }

    if (colors.tertiary) {
      root.style.setProperty('--channel-tertiary-color', colors.tertiary);
    }

    if (colors.highlight) {
      root.style.setProperty('--channel-highlight-color', colors.highlight);
    }
  }

  resetToDefault() {
    const root = document.documentElement;

    root.style.removeProperty('--channel-primary-color');
    root.style.removeProperty('--channel-secondary-color');
    root.style.removeProperty('--channel-tertiary-color');
    root.style.removeProperty('--channel-highlight-color');
    root.removeAttribute('channel-theme');
  }
}